export const arePreferencesReady = (): boolean => window.similarweb?.config?.userData?.preferences !== undefined;
